import { createSlice } from "@reduxjs/toolkit"

const initialCustomersState = {
	currentCustomer: null,
	currentSite: null,
	currentLevel: null,
	veeaHubSerialNumber: null,
	veeaHubRedirectUrl: null,
	veeaExpiryDate: null,
	veeaisPaid: null,
	veeaHubAPIURL: null,
	veeaLicenseisValid: null
}

export const callTypes = {
	list: "list",
	action: "action"
}

export const profileSlice = createSlice({
	name: "profile",
	initialState: initialCustomersState,
	reducers: {
		customerSelected: (state, action) => {
			state.currentCustomer = action.payload
			state.lastError = state.error
			state.error = null
		},
		siteSelected: (state, action) => {
			state.currentSite = action.payload
			state.lastError = state.error
			state.error = null
		},
		floorPlanSelected: (state, action) => {
			state.currentFloorPlan = action.payload
			state.lastError = state.error
			state.error = null
		},
		levelSelected: (state, action) => {
			state.currentLevel = action.payload
			state.lastError = state.error
			state.error = null
		},
		userProfileFetched: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.userProfile = action.payload.userProfile
		},
		layerTypesFetched: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.currentCustomer.layerTypes = action.payload
		},
		veeaHubSerialNumberFetched: (state, action) => {
			state.veeaHubSerialNumber = action.payload.veeaHubSerialNumber
			state.veeaHubRedirectUrl = action.payload.veeaHubRedirectUrl
			state.veeaExpiryDate = action.payload.veeaExpiryDate
			state.veeaisPaid = action.payload.veeaisPaid
			state.veeaHubAPIURL = action.payload.veeaHubSerialNumber
				? `https://veea-vision-${action.payload?.veeaHubSerialNumber?.toLowerCase()}.services.veea.io:8601/`
				: null
			state.lastError = state.error
			state.error = null
		},
		veeaLicenseDetailsRefreshed: (state, action) => {
			state.veeaLicenseisValid = action.payload.veeaLicenseisValid
			state.error = null
		}
	}
})
